module.exports = __webpack_public_path__ + "static/media/pen-nib.3e511499.svg";